import type { IQuestion } from "@/types/types";
import { create } from "zustand";
interface QuestionsFormState {
  // STATUS
  questions: IQuestion[];
  isEditing: boolean;
  edited: boolean;
  // ACTIONS
  setQuestions: (allQuestions: IQuestion[]) => void;
  // Actuliza una question
  updateQuestion: (questionID: string, question_data: IQuestion) => void;
  // Elimina una question
  removeQuestion: (questionID: string) => void;
  // Añade una question
  addQuestion: (question_data: IQuestion) => void;
  // Actuliza el modo de edición
  updateIsEditing: (newValue: boolean) => void;
  // Limpia el estado
  clear: () => void;
}

export const useQuestionsForm = create<QuestionsFormState>((set, get) => ({
  // STATUS
  questions: [],
  isEditing: false,
  edited: false,
  // ACTIONS
  updateQuestion: (questionID: string, question_data: IQuestion) => {
    const _questions = get().questions;
    _questions.forEach((question, idx) => {
      if (question.questionId === questionID) {
        _questions[idx] = { ..._questions[idx], ...question_data };
      }
    });

    set({ edited: true, questions: _questions });
  },
  removeQuestion: (questionID: string) => {
    const _questions = get().questions;

    set({
      edited: true,
      questions: _questions.filter(
        (question) => question.questionId !== questionID,
      ),
    });
  },
  addQuestion: (question_data: IQuestion) => {
    const _questions = get().questions;
    _questions.push(question_data);

    set({
      edited: true,
      questions: _questions,
    });
  },
  updateIsEditing: (newValue: boolean) => {
    const tmp = { isEditing: newValue } as any;
    if (newValue === false) {
      tmp.edited = false;
    }
    set(tmp);
  },
  setQuestions: (allQuestions: IQuestion[]) => set({ questions: allQuestions }),
  clear: () => set({ questions: [], isEditing: false, edited: false }),
}));
